import { FaBell } from 'react-icons/fa';

const TicketsTable = ({ events, searchTerm, onViewTickets }) => {
  const hasEvents = events && events.length > 0;

  return (
    <section className="tickets-table-section">
      <div className="tickets-event-list-table">
        <div className="tickets-table-wrapper">
          <table className="tickets-table">
          <thead>
            <tr>
              <th>Event Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {!hasEvents ? (
              <tr>
                <td colSpan="2" className="tickets-text-center">
                  {searchTerm ? 'No matching events found' : 'No events found'}
                </td>
              </tr>
            ) : (
              events.map((event) => (
                <tr key={event.event_id || event._id || event.id}>
                  <td>{event.name}</td>
                  <td>
                    <button
                      className="tickets-view-button"
                      onClick={() => onViewTickets(event.event_id || event._id || event.id)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        </div>
      </div>
    </section>
  );
};

export default TicketsTable;

